import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EntityDataItem,
  InteractCandidateItem,
  InteractQuestionItem,
} from './types';
import { deepClone } from 'src/conversation/utils';
import React, { Reducer } from 'react';

export interface ProcessStepState {
  visible: boolean;
  /** 实体检测选择超时时间 */
  timeout: number;
  /** 实体检测问题 */
  questions: InteractQuestionItem[];
  /** 实体检测结果 */
  answers: InteractCandidateItem[];
  /** 当前问题索引 */
  currentQuestionIndex: number;
  /** 记录自定义答案 */
  customAnswers: InteractCandidateItem[];
  customAnswerOptions: (EntityDataItem & {
    label: string | React.ReactNode;
    value: string | number;
  })[][];
}

const initialState: ProcessStepState = {
  visible: false,
  timeout: 0,
  questions: [],

  answers: [],
  customAnswers: [],
  customAnswerOptions: [],
  currentQuestionIndex: 0,
};

const processStepSlice = createSlice({
  name: 'processStep',
  initialState: deepClone(initialState),
  reducers: {
    setInteractState(
      state: ProcessStepState,
      action: PayloadAction<
        Partial<Pick<ProcessStepState, 'visible' | 'timeout' | 'questions'>>
      >,
    ) {
      Object.assign(state, action.payload);
    },
    setQuestionIndex(state, action: PayloadAction<number>) {
      state.currentQuestionIndex = action.payload;
    },
    setCustomAnswers(state, action: PayloadAction<InteractCandidateItem[]>) {
      state.customAnswers = action.payload;
    },
    setAnswers(state, action: PayloadAction<InteractCandidateItem[]>) {
      state.answers = action.payload;
    },
    setCustomOptions(
      state,
      action: PayloadAction<ProcessStepState['customAnswerOptions']>,
    ) {
      state.customAnswerOptions = action.payload;
    },
    resetProcessStepState: () => initialState,
  },
});

export const {
  setInteractState,
  setQuestionIndex,
  setCustomAnswers,
  setAnswers,
  resetProcessStepState,
  setCustomOptions,
} = processStepSlice.actions;
export default processStepSlice.reducer as unknown as Reducer<
  ProcessStepState,
  typeof processStepSlice.actions
>;
